
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';

const namespace: string = 'orders';

@Component<OrderSubmittedModal>({
	components: {
		StandardModal,
		TextButton
	}
})
export default class OrderSubmittedModal extends Vue {
	@Action('resetOrderState', { namespace }) resetOrderState!: () => void;
	@Action('setOrderDetails', { namespace }) setOrderDetails!: (orderDetails: OrderDetails) => void;
	@Action('setSelectedInquiryFormRequest', { namespace: 'inquiryForm' }) private setSelectedInquiryFormRequest!: (request: InquiryFormRequest | null) => void;
	@Getter('getOrderDetails', { namespace }) orderDetails!: OrderDetails;
	@Getter('getModifyingOrder', { namespace }) isModifyingOrder!: boolean;
	@Getter('isQuoting', { namespace }) private isQuoting!: boolean;
	@Getter('getSelectedInquiryFormRequest', { namespace: 'inquiryForm' }) private inquiryFormRequest!: InquiryFormRequest | null;
	@Getter('hasPermission', { namespace: 'auth' }) hasPermission!: (permission: PERMISSION) => boolean;
	@Prop({ type: Boolean, required: true }) showSubmittedModal!: boolean;
	@Prop({ type: String, required: false }) returnPath!: string;

	private PERMISSION = PERMISSION;

	private get isAppWebView(): boolean {
		return !!window.B2BApp;
	}

	/**
	 * Reset the order state and open order details modal
	 *
	 * @return {void}
	 */
	private newOrder(): void {
		this.resetOrderState();

		if (this.isQuoting) {
			this.setSelectedInquiryFormRequest(null);
		}

		this.$emit('new-order');
	}

	/**
	 * Navigate back to the inquiries page
	 *
	 * @return {void}
	 */
	private backToInquiries(): void {
		this.resetOrderState();
		this.$router.push('/inquiries').catch(() => {});
	}

	/**
	 * Back to app (go back to the open tabs list)
	 * No need to validate if the app is in webview or not, as this function
	 * wouldn't be hit if the app wasn't in webview.
	 *
	 * @return {void}
	 */
	private backToApp(): void {
		window.B2BApp.backToApp();
	}

	/**
	 * Create a new order with the same details as the current order
	 *
	 * @return {void}
	 */
	private reorder(): void {
		const orderDetailsCopy = { ...this.orderDetails };
		this.resetOrderState();
		this.setOrderDetails(orderDetailsCopy);
		this.$emit('reorder');
	}
}
